import React from 'react'

export default function ProviderSplitFooter({
  changedCount,
  hasErrors,
  onCancel,
  onSave,
}) {
  let message = 'No unsaved changes'
  if (changedCount > 0) {
    message = `${changedCount} unsaved change${changedCount === 1 ? '' : 's'}${
      hasErrors ? ' · fix totals to save' : ''
    }`
  }

  return (
    <div
      className="lox-provider-split__footer"
      data-testid="provider-split-footer"
    >
      <span data-testid="provider-split-footer-message">{message}</span>
      <div className="lox-form__buttons-wrapper has-text-right">
        <button
          type="button"
          className="button has-background-grey has-text-white is-small mr-1"
          onClick={onCancel}
          data-testid="provider-split-footer-cancel"
        >
          <span className="mx-3">Cancel</span>
        </button>
        <button
          type="button"
          className="button is-link is-small ml-1"
          onClick={onSave}
          disabled={changedCount === 0 || hasErrors}
          data-testid="provider-split-footer-save"
        >
          Save changes
        </button>
      </div>
    </div>
  )
}
